import { useState } from "react";
import { CHANGELOG } from "../changelog";
import { LOCALE_NAMES, getLocale, setLocale, t, type Locale } from "../i18n";

/** Every entry, for anyone who wants more than the three on the front page. */
export function Changelog() {
  const [, redraw] = useState(0);
  const locale = getLocale();

  return (
    <div className="landing">
      <div className="landing__lang">
        <select
          className="select select--compact"
          value={locale}
          aria-label="Language"
          onChange={(event) => {
            setLocale(event.target.value as Locale);
            redraw((n) => n + 1);
          }}
        >
          {Object.entries(LOCALE_NAMES).map(([code, name]) => (
            <option key={code} value={code}>
              {name}
            </option>
          ))}
        </select>
      </div>

      <header className="landing__hero">
        <h1>{t("landing.updates")}</h1>
        <p className="landing__tagline">
          <span>Tarkov ShareMap</span>
        </p>
      </header>

      <section className="landing__section landing__changes">
        {CHANGELOG.map((entry, index) => (
          <div key={`${entry.date}-${index}`} className="landing__change">
            <time dateTime={entry.date}>{entry.date}</time>
            <ul>
              {(locale === "ja" ? entry.ja : entry.en).map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
        ))}
      </section>

      <footer className="landing__foot">
        <nav>
          <a href="/">Tarkov ShareMap</a>
          <a href="/help">{t("sidebar.help")}</a>
        </nav>
      </footer>
    </div>
  );
}
